import React from 'react';

export default function LevelUpModal({ isOpen, newLevel, onClose }) {
	if (!isOpen || !newLevel) return null;

	return (
		<div className="modal-overlay">
			<div className="modal-content level-up-modal" role="dialog" aria-modal="true" aria-labelledby="level-up-title">
				<div className="level-up-burst" aria-hidden="true" />
				<div className="level-up-icon" aria-hidden="true">
					<span className="level-up-star">&#11088;</span>
				</div>
				<h3 className="level-up-title" id="level-up-title">Level Up!</h3>
				<div className="level-up-number">Level {newLevel}</div>
				<p className="level-up-subtitle">
					Keep catching ducks and writing adventures to keep climbing.
				</p>
				<div className="level-up-actions">
					<button className="btn btn-orange" onClick={onClose}>Let's Go!</button>
				</div>
			</div>
		</div>
	);
}
